export class Convert {
  static toString(value, defaultValue) {
    if (defaultValue !== undefined && value === undefined) {
      return defaultValue
    }

    if (value === null) {
      return defaultValue
    }

    return value.toString()
  }
  static toInteger(value, defaultValue) {
    if (defaultValue !== undefined && value === undefined) {
      return defaultValue
    }
    if (value === null) {
      return defaultValue
    }
    return parseInt(value)
  }
  static toFloat(value, defaultValue) {
    if (defaultValue !== undefined && value === undefined) {
      return defaultValue
    }
    if (value === null) {
      return defaultValue
    }
    if ((typeof value === 'string' || value instanceof String) && !value.trim()) {
      return defaultValue
    }
    return parseFloat(value)
  }
  static toBoolean(value, defaultValue) {
    if (defaultValue !== undefined && value === undefined) {
      return defaultValue
    }
    if (value === null) {
      return defaultValue
    }
    if ((typeof value === 'string' || value instanceof String) && value.toLowerCase() === 'false') {
      return false
    }
    return !!value
  }
  static tryToFloat(value) {
    //  This function attempts a parse to float. If it can't it returns null without throwing.
    //  Caller can check for null and use original value if desired.
    if (isNaN(value) || value === null) {
      return null
    }
    let number = parseFloat(value)
    if (isNaN(number)) {
      return null
    }
    return number
  }

  //  For converting nodaTime ISO-like string to ISO compliant string. Currently truncates off the
  //  non-ISO stuff, but if the precision is needed we could convert that to fractional seconds.
  static toISODurationString(value, defaultValue) {
    if (value === undefined || value === null) {
      return defaultValue !== undefined ? defaultValue : value
    }

    if (typeof value !== 'string') {
      throw new Error('this method does not support converting from type ' + typeof value)
    }
    return value.replace(/(\d+s)?(\d+n)?(\d+t)?$/g, '')
  }

  static toArray(value, defaultValue) {
    if (defaultValue !== undefined && value === undefined) {
      return defaultValue
    }

    if (value === null) {
      return defaultValue
    }

    if (!Array.isArray(value)) {
      return defaultValue
    }
    return value
  }
}
export default { Convert }
